import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/api/client";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { HardHat, ArrowLeft } from "lucide-react";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const token = sp.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (pw !== pw2) return setErr("Пароли не совпадают");
    if (pw.length < 6) return setErr("Минимум 6 символов");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      setTimeout(() => nav("/login"), 1800);
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || "Ошибка");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#0b0f17] grain-bg flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-11 h-11 rounded-lg bg-amber-500/15 border border-amber-500/40 flex items-center justify-center">
            <HardHat className="text-amber-400" size={22} />
          </div>
          <div>
            <div className="font-display font-extrabold text-2xl text-amber-500 leading-none">Grandmont</div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500 mt-1">Новый пароль</div>
          </div>
        </div>

        {done ? (
          <>
            <h1 className="font-display font-bold text-2xl mb-2 text-emerald-400">Пароль обновлён</h1>
            <p className="text-slate-400 text-sm">Перенаправляем на вход…</p>
          </>
        ) : (
          <>
            <h1 className="font-display font-bold text-2xl mb-2">Задать новый пароль</h1>
            <p className="text-slate-400 text-sm mb-6">Придумайте новый пароль — минимум 6 символов.</p>
            <form onSubmit={submit} className="space-y-5">
              <div>
                <Label className="text-slate-300 mb-1.5 block">Новый пароль</Label>
                <Input data-testid="reset-password-input" type="password" required value={pw}
                       onChange={(e) => setPw(e.target.value)}
                       className="bg-[#131924] border-[#212b3d] focus:border-amber-500 h-11" />
              </div>
              <div>
                <Label className="text-slate-300 mb-1.5 block">Повторите пароль</Label>
                <Input data-testid="reset-password-confirm" type="password" required value={pw2}
                       onChange={(e) => setPw2(e.target.value)}
                       className="bg-[#131924] border-[#212b3d] focus:border-amber-500 h-11" />
              </div>
              {err && <div className="text-red-400 text-sm bg-red-500/10 border border-red-500/30 rounded-md p-2.5">{err}</div>}
              <Button data-testid="reset-submit-button" type="submit" disabled={busy || !token}
                      className="w-full h-11 bg-amber-500 hover:bg-amber-600 text-slate-900 font-semibold">
                {busy ? "Сохранение…" : "Обновить пароль"}
              </Button>
            </form>
            <div className="mt-6">
              <Link to="/login" className="text-slate-400 hover:text-amber-400 text-sm inline-flex items-center gap-1">
                <ArrowLeft size={14} /> К входу
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
